import React from "react";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";

export default function MainLayout1({ children }) {
  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12}>
            {children}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
